module.exports = __webpack_public_path__ + "static/media/QuickMenuIcon02.fc8ed2cc.svg";